import { connect } from "react-redux";
import { RequestAccessForm } from "./RequestAccessForm";
import { sendDocumentRequest } from "../../actions/companyActions";
import { showToast } from "utils/helpers";

export const RequestAccessDocumentComponent = ({
	companyId,
	documentId,
	userId,
	onSuccessfulSubmit,
	sendDocumentRequest,
	...props
}) => {
	const handleSubmit = async (values, { setErrors }) => {
		values["owner_company_id"] = companyId;
		try {
			await sendDocumentRequest(companyId, values);
			onSuccessfulSubmit();
			showToast("Request Submitted successfully.", "Success", true);
		} catch (e) {
			const error = e.response.json();
			setErrors(error.errors);
			showToast(error.message, "Error");
		}
	};

	return (
		<RequestAccessForm
			userId={userId}
			documentId={documentId}
			handleSubmit={handleSubmit}
			title="Request Document Access"
		/>
	);
};

const mapStateToProps = (state) => {
	const userId = state.auth.user.id;
	const companyId = state.search.activeCompany.id;

	return {
		companyId: companyId,
		userId: userId,
	};
};

export const RequestAccessModal = connect(mapStateToProps, {
	sendDocumentRequest,
})(RequestAccessDocumentComponent);
